import Route from './route.element.js';

export default Route;

Route.define('wje-route', Route);
